export default function AuraViewer() {
  return (
    <div className="w-screen h-screen">
      <iframe
        src="https://auradisplay.es"
        className="w-full h-full border-none"
        title="Aura Display"
        allow="camera; microphone; geolocation"
      />
    </div>
  );
}
